import * as types from "./types"

const getPeriodeRpjmd_newSakatoplan_act = () => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_PERIODERPJMD_NEWSAKATOPLAN_START });
    const response = await Api.getPeriodeRpjmd_newSakatoplan();
    if(response.status !== "failed") {
        dispatch({
            type: types.GET_PERIODERPJMD_NEWSAKATOPLAN_SUCCESS,
            payload: {
                data: response.data.data,
                timestamp: response.data.timestamp ?? null,
                message: response.data.message,
                author: response.data.author ?? null
            },
        })
    } else {
        dispatch({
            type: types.GET_PERIODERPJMD_NEWSAKATOPLAN_FAILED,
            payload: {
                message: response.error
            }
        })
    }
}

const getIkuRpjmd_newSakatoplan_act = (periode_id) => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_IKURPJMD_NEWSAKATOPLAN_START })
    const response = await Api.getIkuRpjmd_newSakatoplan(periode_id)
    if(response.status !== "failed") {
        dispatch({
            type: types.GET_IKURPJMD_NEWSAKATOPLAN_SUCCESS,
            payload: {
                data: response.data.data,
                timestamp: response.data.timestamp ?? null,
                message: response.data.message,
                author: response.data.author ?? null
            },
        })
    } else {
        dispatch({
            type: types.GET_IKURPJMD_NEWSAKATOPLAN_FAILED,
            payload: {
                message: response.error
            }
        })
    }
}

const getListOpdIkd_newSakatoplan_act = (periode_id) => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_LISTOPDIKD_NEWSAKATOPLAN_START })
    const response = await Api.getListOpd_newSakatoplan(periode_id)
    if(response.status !== "failed") {
        dispatch({
            type: types.GET_LISTOPDIKD_NEWSAKATOPLAN_SUCCESS,
            payload: {
                data: response.data.data,
                timestamp: response.data.timestamp ?? null,
                message: response.data.message,
                author: response.data.author ?? null
            },
        })
    } else {
        dispatch({
            type: types.GET_LISTOPDIKD_NEWSAKATOPLAN_FAILED,
            payload: {
                message: response.error
            }
        })
    }
}

const getDataIkd_newSakatoplan_act = (periode_id, skpd_id) => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_DATAIKD_NEWSAKATOPLAN_START })
    const response = await Api.getIkkOpd_newSakatoplan(periode_id, skpd_id)
    if(response.status !== "failed") {
        dispatch({
            type: types.GET_DATAIKD_NEWSAKATOPLAN_SUCCESS,
            payload: {
                data: response.data.data,
                timestamp: response.data.timestamp ?? null,
                message: response.data.message,
                author: response.data.author ?? null
            },
        })
    } else {
        dispatch({
            type: types.GET_DATAIKD_NEWSAKATOPLAN_FAILED,
            payload: {
                message: response.error
            }
        })
    }
}

const getDataIup_newSakatoplan_act = (periode_id) => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_DATAIUP_NEWSAKATOPLAN_START })
    const response = await Api.getIup_newSakatoplan(periode_id)
    if(response.status !== "failed") {
        dispatch({
            type: types.GET_DATAIUP_NEWSAKATOPLAN_SUCCESS,
            payload: {
                data: response.data.data,
                timestamp: response.data.timestamp ?? null,
                message: response.data.message,
                author: response.data.author ?? null
            },
        })
    } else {
        dispatch({
            type: types.GET_DATAIUP_NEWSAKATOPLAN_FAILED,
            payload: {
                message: response.error
            }
        })
    }
}

export {
    getPeriodeRpjmd_newSakatoplan_act,
    getIkuRpjmd_newSakatoplan_act,
    getListOpdIkd_newSakatoplan_act,
    getDataIkd_newSakatoplan_act,
    getDataIup_newSakatoplan_act
}